export default __webpack_public_path__ + "static/media/spin-banner-mobile.81c668a4.png";